<template>
    <div class="column-option co-checkbox">
        <div class="custom-control custom-switch">
            <input class="custom-control-input" :id="uniqKey" type="checkbox" v-model="valueExt">
            <label class="custom-control-label" :for="uniqKey">{{ label }}</label>
        </div>
    </div>
</template>

<script>
export default {
    name: "check-option",
    props: ['option', 'index', 'value', 'uniq', 'label'],
    model: {
        prop: 'value',
        event: 'valuechange'
    },
    data(){
        return {

        }
    },
    computed: {
        uniqKey(){
            return this.uniq;
        },

        valueExt: {
            get: function () {
                // Задача этой штуки - вернуть true/false для установления начального значения "галочки"
                if(typeof this.value === 'undefined') return false;
                if(typeof this.value[this.option] === 'undefined') return false;
                if(Array.isArray(this.value)) return false;

                if(this.value[this.option] === 'false') return false;

                return true;
            },
            set: function (value) {
                let option = this.option;

                let newValueText = (value)?"true":"false";
                let val = this.value;
                val[this.option] = newValueText;

                this.$emit('valuechange', val);
                this.$emit('change', val, this.index);

            }
        }
    }
}
</script>

<style scoped>

</style>
